import React from 'react';
import { I18nextProvider } from 'gatsby-plugin-react-i18next';
import { getI18n, whenI18nReady } from 'common/src/i18n';

interface I18nProviderProps {
  children: React.ReactNode;
}

const I18nProvider = ({ children }: I18nProviderProps) => {
  const [ready, setReady] = React.useState(false);
  React.useEffect(() => {
    let cancelled = false;
    whenI18nReady().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) return null;

  return <I18nextProvider i18n={getI18n()}>{children}</I18nextProvider>;
};

export default I18nProvider;
